import { api } from '@/api';

export * from './localization';
export * from './referrals';

const createInvestor = (data) => {
  return api.post('/api/v1/investor', data);
};

const updateInvestor = (data) => {
  return api.put('/api/v1/investor', data);
};

const setCitizenship = (countryId) => {
  return api.post('/api/kyc/v1/investor/citizenship', { countryId });
};

const uploadAvatar = (file) => {
  const formData = new FormData();
  formData.append('file', file);

  return api.post('/api/kyc/v1/investor/avatar', formData);
};

const verifyPhone = (code, id) => {
  return api.post('/api/v1/investor/verifyPhone', { code: code, id: id });
};

const verifyEmail = (code) => {
  return api.post('/api/v1/investor/verifyEmail', { code: code });
};

const sendPhoneCode = () => {
  return api.get('/api/v1/investor/sendPhoneSms');
};

const sendEmailCode = () => {
  return api.get(`/api/v1/investor/sendEmailSms`);
};
const changeEmailOrCode = ({ newPhone, newEmail }) => {
  return api.put('/api/v1/investor/registration-contact-info', {
    newPhone,
    newEmail
  });
};
const phoneEmailValidation = (phone, email, account) => {
  return api.get('/api/v1/investor/validation', {
    params: { phone: phone, email: email, account: account }
  });
};

const createPersonalAccount = (accountName = 'Personal account') => {
  return api.post('/api/v1/investor/personalAccount', { accountName: accountName });
};

const getInvestor = () => {
  return api.get('/api/v1/investor');
};
const getCitizenship = () => {
  return api.get('/api/kyc/v1/investor/citizenship');
};
const getAdditionalInfoQuestId = () => {
  return api.get('/api/kyc/v1/investor/questionnaires/PersonalData');
};

const getReferralToken = (investorId) => {
  return api.post('/api/kyc/v1/agent/token', { investorId });
};
const downloadPdfAgent = ({ url, token }) => {
  return api.get(`/agent/${url}`, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
};

const getInvestorNotifications = (params) => {
  return api.get('/api/kyc/v1/investor/notifications', {
    params: { ...params }
  });
};

const readInvestorNotifications = (notificationIds) => {
  return api.put('/api/kyc/v1/investor/notifications/read', {
    notificationIds: notificationIds
  });
};

const getInvestorScoring = (questionSectionTypeId) => {
  return api.get('/api/kyc/v1/investor/scoring/questionSectionType', {
    params: {
      questionSectionTypeId: questionSectionTypeId
    }
  });
};

export const investorApi = {
  createInvestor,
  updateInvestor,
  setCitizenship,
  uploadAvatar,
  verifyPhone,
  verifyEmail,
  sendPhoneCode,
  sendEmailCode,
  phoneEmailValidation,
  createPersonalAccount,
  getInvestor,
  getCitizenship,
  getAdditionalInfoQuestId,
  getReferralToken,
  downloadPdfAgent,
  getInvestorNotifications,
  readInvestorNotifications,
  getInvestorScoring,
  changeEmailOrCode
};

export const investorKeys = {
  getInvestorScoring: 'investor.getInvestorScoring'
};
